export default __webpack_public_path__ + "static/media/i157hp.d2863a80.webp";